var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadiobuttonChecked = function SvgRadiobuttonChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25c-14 0-25 11-25 25s11 25 25 25 25-11 25-25-11-25-25-25zm0-25C22.5 0 0 22.5 0 50s22.5 50 50 50 50-22.5 50-50S77.5 0 50 0zm0 90c-22 0-40-18-40-40s18-40 40-40 40 18 40 40-18 40-40 40zm0 0"
  })));
};
export default SvgRadiobuttonChecked;